import { RowValueDto } from "@app/applications/applications.model";
import { Liability } from "../../financials/liability/liability.model";

export class BureauResponse {
	constructor(
		public requestReferenceId?: string,
		public token?: string,
		public queueName?: string,
		public score?: string,
		public writeOffs?: number,
		public past30DaysEnquries?: string,
		public past12MonthsEnquiries?: string,
		public past6MonthsEnquiries?: string,
		public maxWorstDelequency?: string,
		public past24MonthsEnquries?: string,
		public message?: string,
		public hitCode?: string,
		public status?: string,
		public responseStatus?: string,
		public statusCode?: string,
		public reportNumber?: string,
		public totalEnquiry?: number,
		public totalPastDueAmount?: number,
		public suitFiledAccountCount?: number,
		public npaAccountCount?: number,
		public settledAccountCount?: number,
		public bureauDetails?: RowValueDto,
		public validationDetailDTO?: validationDetailDTO,
		public bureaureportuid?: string,

		public verificationStatus?: string,
		public liabilities?: Liability[],
		public challengeId?: string,
		public answerId?: string,
		public questionId?: string,
		public questionText?: string,
		public allowResend?: boolean,
		public cibilReportUrl?: string
	) { }
}

export class validationDetailDTO {
	constructor(
		public acceptanceCriteriaMet: boolean,
		public inPermissibleTolerance: boolean,
		public validationMessages: string[],
	) { }
}

export class BureauRequestDto {
	constructor(
		public applicationUid?: string,
		public applicationNo?: string,
		public branchCode?: string,
		public linkToType?: string,
		public linkToUid?: string,
		public purposeCode?: string,
		public requestReferenceId?: string,
		public challengeId?: string,
		public answerId?: string,
		public questionId?: string,
		public answerText?: string,
		public skipQuestion?: boolean,
		public resendOtp?: boolean,
		public currentStep?: string
	) { }
}